export default __webpack_public_path__ + "static/media/P1000-Plunger.d9cd90ae.svg";